//* Import libraries
import { useState, useCallback, useEffect } from "react";

//* Import react-router hooks
import { Link, useNavigate } from "react-router-dom";

//* Import components
import { List } from "../../../component/list/list";
import { Loading } from "../../../component/common/Loading";

//* Import custom hooks
import { useDemands } from "../../../hooks/demand/useDemands";

import { Demands } from "../../../hooks/demand/types/types";
import { Button, Form, Spinner, Row, Col } from "react-bootstrap";
import { Attention } from "../../../component/base/Attention";
import ModalMensagem from "../../../component/base/ModalMensagem";

var debounce = require("lodash.debounce");

export function Controle() {
  const token = localStorage.getItem("token") || "";

  const [answers, setAnswers]: any = useState({});

  const onchangeInput=(e:any,key:any)=>{
    if(e.target.value!='' && Number.isNaN(e.target.value)){
      return;
    }

    let answers_ = { ...answers }
    answers_[key] =e.target.value==''?'': parseInt(e.target.value)
    setAnswers(answers_)
  }





  return (
    <div className="row">
      <div className="col-12">

        <div className={"py-5 px-3"}>
          <div className={"card-body"} id="card">
            <h4
              className="mt-0 header-title"
              style={{ fontSize: "2.0rem", color: "black" }}
            >
              Controle e liberdade do usuário
            </h4>
            <br></br>
            <br></br>
            <h4
              className="mt-0 header-title"
              style={{ fontSize: "1.5rem", color: "black" }}
            >
              Explicação da heurística:
            </h4>
            <br></br>
            <p align="justify"> <strong> Essa heurística determina que, durante todo o tempo de uso do software científico, o usuário terá controle das suas ações e terá liberdade para operar todo 
              o software. Quando ações que bloqueiam o usuário forem necessárias, o software deve comunicar o motivo e mostrar as mudanças de status até que o bloqueio termine. 
              Além disso, o software deve apresentar funções de recuperação para quando o usuário realizar uma ação e for necessário voltar para o status anterior. Exemplo: 
              Quando o usuário executar uma tarefa que requer muito processamento e não forem permitidas inserções de novos dados durante a execução da tarefa, o software deve 
              desabilitar o botão de inserção de dados e apresentar uma mensagem indicando que essa função só estará disponível quando o processamento terminar. </strong> </p>
            <p align="justify"> <strong> A heurística Controle e liberdade do usuário foi subdivida em dois critérios de análise, a saber: Controle total do software (C1) e Recuperação de ação (C2). </strong> </p>
            <br></br>
              <h4
              className="mt-0 header-title"
              style={{ fontSize: "1.5rem", color: "black" }}
            >
              Perguntas para avaliação:
            </h4>
            <br></br>

            <Form.Group className="mb-3">
              <Form.Label style={{fontSize:18}} align="justify">
              P1.C1) O software apresenta algum bloqueio de funções? Indique o número de bloqueios (N) <Attention />
              </Form.Label>
              <div>
                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de bloqueios: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['1_1'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'1_1')
                    }}
                    required
                    
                  />
                  
                </div>
              </div>
            </Form.Group>


            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{fontSize:18}} align="justify">
              P1-1.C1)   Durante os bloqueio existentes o usuário é comunicado? Indique o número de avisos que ocorrem (Qb) <Attention />
              </Form.Label>
              <div>
                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de avisos que ocorrem: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['1_2'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'1_2')
                    }}
                    required
                    
                  />
                  
                </div>
              </div>
            </Form.Group>
            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{fontSize:18}} align="justify">
              P1-2.C1)   Quando os bloqueios terminam o usuário é comunicado? Indique o número de avisos que ocorrem (Qa). Exemplo de comunicação: Aviso sonoro que chame a atenção do 
              usuário ou uma notificação na tela, independentemente se o software científico está sendo executado em segundo plano. <Attention />
              </Form.Label>
              <div>
                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de avisos que ocorrem: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['1_3'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'1_3')
                    }}
                    required
                    
                  />
                  
                </div>
              </div>
            </Form.Group>
            <br></br>
            <Form.Group className="mb-3">
              <Form.Label style={{fontSize:18}} align="justify">
              P1.C2)   O software apresenta funções de recuperação que permitam que o usuário volte a um status anterior ao se arrepender de uma ação? Indique o número de situações 
              que funções de recuperação podem ser implementadas (N) e a quantidade de funções existentes (Q). Exemplos de função: botão de voltar posicionado sempre no mesmo local 
              da interface que permite ao usuário voltar para uma tela/página anterior.. <Attention />
              </Form.Label>
              <div>
                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Número de situações que funções de recuperação podem ser implementadas: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['2_1'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'2_1')
                    }}
                    required
                    
                  />
                  
                </div>

                <div className="d-flex align-items-center mb-2">

                <span style={{ fontSize: '1.2rem' }}>Quantidade de funções existentes: &nbsp;</span>
                  <Form.Control
                    placeholder=""
                    style={{ width: 42, padding: 0, marginRight: 10, textAlign: 'center' }}
                    value={answers['2_2'] ?? ''}
                    onChange={(e) => {

                      onchangeInput(e,'2_2')
                    }}
                    required
                    
                  />
                  
                </div>
              </div>
            </Form.Group>

            <br></br>

            <button onClick={(e)=>{

            }} className="btn btn-success btn-lg w-100">
                          Gerar resultado
                        </button>
            <ModalMensagem/>

           












          </div>
        </div>
      </div>

    </div>
  );
}
